import ToastView from './src/toastView.vue';

/* istanbul ignore next */
ToastView.install = function(Vue) {
    Vue.component(ToastView.name, ToastView);
};

export default ToastView;